import { Link } from 'react-router-dom';

const footerLinks = {
  gameCategories: [
    { name: '电子游艺', path: '/category/slots' },
    { name: '真人视讯', path: '/category/live' },
    { name: '体育电竞', path: '/category/sports' },
    { name: '彩票游戏', path: '/category/lottery' },
    { name: '捕鱼游戏', path: '/category/fishing' },
    { name: '棋牌游戏', path: '/category/board' },
  ],
  quickLinks: [
    { name: '关于我们', path: '/about' },
    { name: '最新资讯', path: '/category/all?tab=articles' },
    { name: '优惠活动', path: '/#promotions' },
    { name: '用户协议', path: '/about' },
    { name: '隐私政策', path: '/about' },
    { name: '责任博彩', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-gamepad-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">九游娱乐</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed mb-5 max-w-sm">
              九游娱乐是值得信赖的综合游戏娱乐平台，汇聚海量精品游戏与丰厚福利活动，专业客服全天候护航，安全稳定，乐趣无限。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-5">游戏分类</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.gameCategories.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-foreground-400 text-sm hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-5">快速链接</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-foreground-400 text-sm hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-5">联系我们</h4>
            <ul className="flex flex-col gap-3 text-foreground-400 text-sm">
              <li className="flex items-start gap-2.5">
                <i className="ri-customer-service-line text-accent-500 mt-0.5 text-sm"></i>
                <span>客服热线：400-888-9999</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line text-accent-500 mt-0.5 text-sm"></i>
                <span>service@jiuyou.com</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line text-accent-500 mt-0.5 text-sm"></i>
                <span>7×24小时在线服务</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 九游娱乐 版权所有 | 18+ 理性游戏 拒绝沉迷
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-500 text-xs hover:text-background-200 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-background-200 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-background-200 transition-colors cursor-pointer" rel="nofollow">责任博彩</a>
          </div>
        </div>
      </div>
    </footer>
  );
}